const storageKey = "bookburrow-invitation";

// The synchronous public/invitation-bootstrap.js captures and scrubs the URL.
export function invitationToken() { return sessionStorage.getItem(storageKey); }
export function clearInvitation() { sessionStorage.removeItem(storageKey); }
